export type Tag = {
  id: number;
  group1Id: number;
  group2Id: number;
  group3Id: number;
  tagName: string;
  tagType1: string;
  tagType2: string;
  updatedAt: string;
  createdAt: string;
};

export interface TagItem extends Tag {
  count?: number;
  numMovies?: number;
  isSelected: boolean;
  isPartiallySelected: boolean;
  isNew: boolean;
}

export type AdminTag = Omit<Tag, 'tagType2'> & {
  // 管理タグの tag_type2 はレスポンスに含まれないことがあるため optional とする。
  tagType2?: string;
};

export type AdminTagIndexItem = AdminTag & {
  tagMovieNum: number;
  createdAtDate: string;
};

export interface TagInputModel {
  id: number | null; // null = 新規作成
  tagName: string;
  group2Id: number | null;
  group3Id: number | null;
}

export const createTagInitInputModel = (): TagInputModel => ({
  id: null,
  tagName: '',
  group2Id: null,
  group3Id: null,
});
